import { render, staticRenderFns } from "./BusinessUserPin.vue?vue&type=template&id=25d81680&scoped=true&"
import script from "./BusinessUserPin.vue?vue&type=script&lang=js&"
export * from "./BusinessUserPin.vue?vue&type=script&lang=js&"
import style0 from "./BusinessUserPin.vue?vue&type=style&index=0&id=25d81680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d81680",
  null
  
)

export default component.exports